import { Link } from "react-router-dom";
import { Box, Button, Container, Paper, Typography } from "@mui/material";
import { getDashboardPath } from "@/helpers/utils";

type RRDDirectMailJoinCampThankYouPageProps = {
  isNationalPlusUp?: boolean;
};

const RRDDirectMailJoinCampThankYouPage = ({
  isNationalPlusUp = false,
}: RRDDirectMailJoinCampThankYouPageProps) => {
  const title = isNationalPlusUp
    ? "Your National Coupon Plus Up Is Confirmed"
    : "Your Direct Mail Campaign Is Confirmed";
  const intro = isNationalPlusUp
    ? "Thanks for launching a National Coupon Plus Up campaign with Hyperlocology!"
    : "Thanks for launching a local Direct Mail campaign with Hyperlocology!";

  return (
    <Container maxWidth="md">
      <Paper elevation={2}>
        <Box
          className="pl-3 rrd-thankyou-page"
          display="flex"
          justifyContent="flex-start"
          alignItems="flex-start"
          flexDirection="column"
          p={3}
        >
          <div className="text-start">
            <Typography variant="h5" className="fw-b ml-2 mt-2 mb-4">
              {title}
            </Typography>

            <Typography className="ml-2 description mb-2 fw-sb" variant="body2">
              {intro}
            </Typography>

            <Box className="d-flex align-items-start flex-column my-2 description-box p-2">
              <Typography className="description mt-2 mb-2" variant="body2">
                Your campaign is officially moving into production and scheduled
                for in-home delivery.
              </Typography>

              <Typography className="description mt-2 mb-2" variant="body2">
                Your campaign will use smart targeting to ensure your message
                reaches the right households, maximizing impact, efficiency, and
                measurable results.
              </Typography>

              <Typography
                className="fw-b mb-3 description mt-2"
                variant="body2"
              >
                What to expect
              </Typography>

              <Box
                className="mb-3"
                sx={{
                  "& ol": {
                    listStyle: "none",
                    counterReset: "item",
                    paddingLeft: 0,
                    margin: 0,
                  },
                  "& li": {
                    counterIncrement: "item",
                    marginBottom: "0.85rem",
                    fontSize: "14px",
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "0.5rem",
                  },
                  "& li::before": {
                    content: "counter(item)",
                    fontWeight: "bold",
                    color: "var(--neutral-700)",
                    flexShrink: 0,
                  },
                }}
              >
                <ol>
                  <li>Final campaign details are confirmed.</li>
                  <li>Mail is scheduled for in-home delivery.</li>
                  <li>Your brand is about to show up where it matters most.</li>
                </ol>
              </Box>

              <Typography className="description mb-2" variant="body2">
                No additional action is required. Everything needed to execute
                your campaign is already in place.
              </Typography>

              {!isNationalPlusUp && (
                <Typography className="description mt-2 mb-2" variant="body2">
                  A confirmation email with PDF images of the exact mailer you
                  selected will be sent for your records.
                </Typography>
              )}

              <Typography className="description mt-2 mb-4" variant="body2">
                And this is just the beginning. Keep an eye out for additional
                local marketing opportunities designed to help you stay
                top-of-mind and keep customers coming through your doors.
              </Typography>

              <Box className="mb-4" sx={{ width: "100%", textAlign: "left" }}>
                <Typography
                  className="description fw-b"
                  fontStyle="italic"
                  variant="body1"
                  color="var(--primary-base)"
                >
                  Let's drive results.
                </Typography>
              </Box>
            </Box>

            <Box
              className="my-2"
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Button
                component={Link}
                to={`${getDashboardPath()}`}
                className="thankyou-btn px-5 ml-2"
                variant="contained"
                color="primary"
                size="large"
              >
                Back to My Dashboard
              </Button>
            </Box>
          </div>
        </Box>
      </Paper>
    </Container>
  );
};

export default RRDDirectMailJoinCampThankYouPage;
